import { setTextColor } from 'common/Prose/Commands/formatting/textColor'
import { TEXT_COLOR_OPTIONS } from 'common/Prose/constants/colorOptions'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import { EditorColorPicker } from '../EditorColorPicker/EditorColorPicker'

export type TextColorPickerProps = {
  view: EditorView
  activeColors: string[]
  callback?: () => void
}

export const TextColorPicker: React.FC<React.PropsWithChildren<TextColorPickerProps>> = (props) => {
  const { view, activeColors, callback } = props
  return (
    <EditorColorPicker
      aria-label={(color: string) => `Change text color to ${color}`}
      includeDropdownStyles={false}
      colorOptions={TEXT_COLOR_OPTIONS}
      activeColors={activeColors}
      setColor={(color) => {
        // the timeout is necessary for certain browsers (safari) not to eat the selection
        setTimeout(() => setTextColor(color, view))
        callback?.()
      }}
    />
  )
}
